import React from 'react';
import './MyRadioGroup.css';

const MyRadioGroup = ({ label, name, options, value, onChange, disabled = false }) => {
  return (
    <div className="my-radio-group-container">
      {label && <span className="my-radio-group-label">{label}</span>}
      <div className="my-radio-group">
        {options.map((option) => (
          <label key={option.value} className="my-radio-option">
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              disabled={disabled}
            />
            <span className="my-radio-button"></span>
            <span className="my-radio-label">{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default MyRadioGroup;